import { IWixAPI } from '@wix/yoshi-flow-editor';

export function getViewMode(wixCodeApi: IWixAPI) {
  return wixCodeApi.window.viewMode.toLowerCase();
}
